module.exports = __webpack_public_path__ + "img/icon-cart.4a480335.png";